// TODO: ability to hide sidebar on collapse after content-min

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-sidebar',
  styleUrl: 'sidebar.css',
  shadow: false,
})
export class Sidebar {
  @Prop() space: string = 'var(--s1)';
  @Prop() contentmin: string = '50%';
  @Prop() sidebarwidth: string = '300px';

  render() {
    return (
      <div class="with-sidebar" style={{'--space': this.space, '--content-min': this.contentmin, '--sidebar-width': this.sidebarwidth}}>
        <div>
          <div><slot name="sidebar" /></div>
          <div><slot name="main" /></div>
        </div>
      </div>
    );
  }
}
